import { Link } from "gatsby"
import React from "react"
const Logo = () => {
  return (
    <Link to="/">
      <div className="font-black text-xl lowercase">
        <span>keep</span>
        <span className="text-blue">it</span>
      </div>
    </Link>
  )
}
const HeaderNav = ({location}) => {
  return (
    <div className="flex items-center max-w-5xl w-full mx-auto text-base sm:text-lg  px-4 py-6 sm:px-6 md:px-8 lg:px-12 xl:px-16 justify-between ">
      <Logo />
      <nav className="flex items-center gap-4 md:gap-8 lg:gap-12">
        <Link to="/pricing">
          <span className={`${location && location.includes('/pricing') ? 'text-blue font-bold' :'hover:text-blue'} transition duration-100`}>Pricing</span>
        </Link>
        <Link to="/contact">
          <span className={`${location && location.includes('/contact') ? 'text-blue font-bold' :'hover:text-blue'} transition duration-100`}>Contact</span>
        </Link>
      </nav>
    </div>
  )
}

export default HeaderNav
